export const getDataSource = (data) =>
    data.map((el, key) => ({
        key: key,
        no: key,
        state: el.label,
        sample: el.percent,
        records: el.records
    }));
